var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"22","height":"20","viewBox":"0 0 22 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M20 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H9L7 19V20H15V19L13 16H20C21.1 16 22 15.1 22 14V2C22 0.9 21.1 0 20 0ZM20 12H2V2H20V12Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }